import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
import React from "react";
import { DeviceType } from "typedefs/DeviceTypes";
export var useDeviceDetection = function useDeviceDetection() {
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    device = _React$useState2[0],
    setDevice = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userAgent = _React$useState4[0],
    setUserAgent = _React$useState4[1];
  React.useEffect(function () {
    var detectDevice = function detectDevice() {
      var userAgent = navigator.userAgent.toLowerCase();
      var isPhone = /iphone|android|blackberry|windows phone/g.test(userAgent);
      var isTablet = /(ipad|tablet)/g.test(userAgent);
      if (isPhone) {
        setDevice(DeviceType.Phone);
      } else if (isTablet) {
        setDevice(DeviceType.Tablet);
      } else {
        setDevice(DeviceType.Desktop);
      }
      setUserAgent(userAgent);
    };
    detectDevice();
    window.addEventListener("resize", detectDevice);
    return function () {
      window.removeEventListener("resize", detectDevice);
    };
  }, []);
  var deviceData = {
    userAgent: userAgent,
    type: device,
    isPhone: device === DeviceType.Phone,
    isTablet: device === DeviceType.Tablet,
    isMobile: device === DeviceType.Phone || device === DeviceType.Tablet,
    isDesktop: device === DeviceType.Desktop
  };
  return deviceData;
};